import { j as s } from "../../../node_modules/react/jsx-runtime.js";
import { memo as u } from "react";
import { clsx as c } from "../../../node_modules/clsx/dist/clsx.m.js";
import m from "./LinkButton.module.scss.js";
import { Typography as d } from "../Typography/Typography.js";
import l from "../Icon/Icon.js";
const j = ({
  label: r,
  variant: i = "primary",
  size: e = "medium",
  disabled: o = !1,
  trailingIcon: a,
  loading: t = !1,
  onClick: n,
  href: f,
  target: p,
  testId: x
}) => /* @__PURE__ */ s.jsxs(
  "a",
  {
    className: c(m.linkButton, m[i], m[e], {
      [m.loading]: t,
      [m.disabled]: o
    }),
    "data-testid": x,
    ...!o && {
      onClick: n,
      tabIndex: 0,
      href: f,
      target: p
    },
    children: [
      !t && r && /* @__PURE__ */ s.jsx(
        d,
        {
          text: r,
          variant: e === "small" ? "interface/medium/s" : "interface/medium/sm"
        }
      ),
      !t && a && /* @__PURE__ */ s.jsx(
        l,
        {
          name: a,
          size: "sm"
        }
      ),
      t && /* @__PURE__ */ s.jsx("div", { className: m.loader })
    ]
  }
), N = u(j);
export {
  N as default
};
//# sourceMappingURL=LinkButton.js.map
